export default __webpack_public_path__ + "static/media/background.c02c78b3.png";